import { IconExclamationTriangleFilled } from '@iwoca/icons';
import classNames from 'classnames';

import styles from './StatusIcons.module.css';

const Required = () => {
    return (
        <span
            className={classNames(styles.status, styles.requiredStatus)}
            data-testid="required-status"
        >
            <IconExclamationTriangleFilled
                className={classNames(styles.statusIcon, styles.requiredIcon)}
                height={20}
                width={20}
            />
            Required
        </span>
    );
};

// eslint-disable-next-line import/no-default-export
export default Required;
